import React from "react";
import http from "../../util/api";
import moment from "moment";

import qs from "qs";
import "./LiveClientRoom.scss";
// import img from "./imgs/tri.png"
import { Toast } from "antd-mobile";
import { getItem, setItem } from "../../util/util";

let timer;
class LiveClientRoom extends React.Component {
  state = {
    name: "",
    sec: 5,
    hasSent: false,
    phone: "",
    otp: "",
    nickname: "",
    illness: { name: "点击选择病种", id: "error" },
    showIllness: false,
    illnessPool: [{ name: "", id: "" }],
    showType: false,
    TypePool: ["患者", "医生"],
    openid: "",
    loginMsg: null,
  };
  async componentDidMount() {
    document.title = "观看直播";
    const search = document.location.search;
    const querystring = search.substring(1);
    let room = qs.parse(querystring).room; //从url中取room
    Toast.loading("搜寻直播间中，请稍后…");
    let loginMsg = getItem("loginMsg") || null;
    if (this.isWeiXin()) {
      let openid = qs.parse(querystring).nsukey;

      if (!openid) {
        let openid2 = getItem("openid");
        if (openid2) {
          this.setState({ openid: openid2 });
        } else {
          // window.location.href =
          //   "http://towerwx.realsun.me/WxAuth/OAuth?returnUrl=" +
          //   window.returnUrl2;
        }
      } else {
        setItem("openid", openid);
        this.setState({ openid: openid });
      }
    }
    if (loginMsg) {
      if (!room) {
        this.setState({ status: "error" });
      } else {
        this.getToken(room);
        let arr = JSON.parse(loginMsg);
        console.log("obj", arr);
        this.setState({
          phone: arr[0].C3_641473640122,
          nickname: arr[0].username,
          hospital_name: arr[0].hospital_name,
          department:arr[0].department,
          jobtitle:arr[0].jobtitle,
          doctor_hospital: arr[0].doctor_hospital,
          currentType: arr[0].doctor_hospital,
          loginMsg: loginMsg,
          illness: { name: arr[0].casetype, id: "default" },
        });
      }
    } else {
      this.setState({ needLoginMsg: true });
    }
    if (!room) {
      this.setState({ status: "error" });
    } else {
      this.getToken(room);
    }
  }
  isWeiXin = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  };
  countDown = () => {
    var _this = this;
    timer = setInterval(() => {
      var t = _this.state.sec;
      if (t > 0) {
        t = t - 1;
        this.setState({ sec: t });
      } else {
        t = 0;
        this.setState({ sec: t, hasSent: false });
        clearInterval(timer);
      }
    }, 1000);
  };
  getIll = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).getIll({
        resid: 677087166188 ,
      });
      console.log('ill',res)
      let n = 0;
      let arr = [];
      while (n < res.data.data.length) {
        arr.push({
          name: res.data.data[n].diease_type,
          id: res.data.data[n].diease,
        });
        n++;
      }
      this.setState({ illnessPool: arr });
    } catch (e) {
      Toast.fail(e.message);
      console.log(e);
    }
  };
  getToken = async (room) => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      this.setState({ name: room });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
      await this.getIll();
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("未找到直播间");
    }
  };
  getOtp = async () => {
    var t = !/^1[3456789]\d{9}$/.test(this.state.phone);
    if (t) {
      Toast.fail("手机号码有误，请重填");
    } else {
      this.countDown();
      this.setState({ sec: 5, hasSent: true });
      let res;
      let url = { baseURL: window.otpUrl };
      res = await http(url).getOtp({
        telephone: this.state.phone,
      });
      if (res.error === "0") {
        Toast.sucess("验证码发送成功");
      } else {
        Toast.error(res.error);
      }
      console.log(res);
    }
  };
  login = async () => {
    const { currentType, hospital_name,jobtitle,department } = this.state;
    var t = !/^1[3456789]\d{9}$/.test(this.state.phone);
    let c = false
    // 取消了手机号和病种
    if (c) {
      // Toast.fail("手机号码有误，请重填");
    } else {
      if (c) {
       // Toast.fail("请选择病种");
      } else {
        if (this.state.nickname) {
          var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
          if (patrn.test(this.state.nickname)) {
            // 如果包含特殊字符返回false
            Toast.fail("昵称不能包含特殊字符！");
          } else {
            if (this.state.nickname.length > 8) {
              Toast.fail("昵称最长为8位！");
            } else {
              Toast.loading("登录中...");

              let res;
              let url = { baseURL: window.liveUrl };
              let obj = [
                {
                  _id: 1,
                  _state: "added",
                  C3_641473978690: this.state.name,
                  // C3_641473640122: this.state.phone,
                  // C3_641473639851:this.state.otp,
                  C3_641473639851: "0000",
                  username: this.state.nickname,
                  doctor_hospital: currentType,
                  hospital_name: hospital_name,
                  jobtitle:jobtitle,
                  department:department,
                  // casetype: this.state.illness.name,
                  wxopenid: this.state.openid,
                },
              ];

              let str = "";
              str = JSON.stringify(obj);
              try {
                res = await http(url).saveLive({
                  resid: "641473602835",
                  data: str,
                });
                setItem("loginMsg", str);
                window.location.href = res.data.data[0].redirecturl;

                // alert('http://towerwx.realsun.me/WxAuth/OAuth?returnUrl='+window.returnUrl2)
                // return(window.location.href = 'http://towerwx.realsun.me/WxAuth/OAuth?returnUrl='+window.returnUrl2)

                // this.props.history.push('/redirect-to-live?user='+this.state.phone+this.state.nickname)
                // +'http://ivf.dybhealth.com:1103/redirect-to-live';
              } catch (e) {
                console.log(e.message);
                Toast.fail(e.message);
              }
            }
          }
        } else {
          Toast.fail("昵称不能为空！");
        }
      }
    }
  };

  render() {
    const { showType, TypePool, currentType } = this.state;
    return (
      <div className="content_live">
        <div
          className={this.state.showIllness ? "selector" : "selector hidden"}
        >
          <ul>
            {this.state.illnessPool.map((item, key) => {
              return (
                <li
                  onClick={() => {
                    this.setState({ selectIll: key });
                  }}
                  className={this.state.selectIll == key ? "current" : ""}
                  key={item.id}
                >
                  {item.name}
                </li>
              );
            })}
          </ul>
          <div className="btnline">
            <button
              onClick={() => {
                this.setState({ showIllness: false });
              }}
            >
              取消
            </button>
            <button
              onClick={() => {
                this.setState({
                  showIllness: false,
                  illness: this.state.illnessPool[this.state.selectIll],
                });
              }}
            >
              确定
            </button>
          </div>
        </div>

        <div className={showType ? "selector" : "selector hidden"}>
          <ul>
            {TypePool.map((item, key) => {
              return (
                <li
                  onClick={() => {
                    this.setState({ currentType: item });
                  }}
                  className={this.state.currentType == item ? "current" : ""}
                  key={item}
                >
                  {item}
                </li>
              );
            })}
          </ul>
          <div className="btnline">
            <button
              onClick={() => {
                this.setState({ showType: false });
              }}
            >
              取消
            </button>
            <button
              onClick={() => {
                this.setState({
                  showType: false,
                  // illness:TypePool[this.state.selectIll],
                });
              }}
            >
              确定
            </button>
          </div>
        </div>
        <h3>{this.state.name}</h3>
        {/* <img src={img} className='el el1'></img> */}
        {/* <img src={img} className='el el2'></img> */}
        {/* <img src={img} className='el el3'></img> */}
        <div className="ctr">
          {/* <h4>您是：</h4>
          <div
            className="illness"
            onClick={() => {
              this.setState({ showType: true });
            }}
          >
            {currentType}
          </div>
          <h4>手机号：</h4>
          <input
            type="number"
            max="11"
            value={this.state.phone}
            onChange={(v) => {
              this.setState({ phone: v.target.value });
            }}
          /> */}
          <h4>医院<span className="asterisk">*</span>：</h4>
          <input
            // max="8"
            value={this.state.hospital_name}
            onChange={(v) => {
              this.setState({ hospital_name: v.target.value });
            }}
          />
          <h4>科室<span className="asterisk">*</span>：</h4>
          <input
            // max="8"
            value={this.state.department}
            onChange={(v) => {
              this.setState({ department: v.target.value });
            }}
          />
          {/* <h4>验证码：</h4>   */}
          {/* <input type='number' max='4' className='short' value={this.state.otp} onChange={(v)=>{this.setState({otp:v.target.value})}}/>  */}
          {/* <button style={{float:'right'}} className={this.state.hasSent?'short unable':'short'} onClick={()=>{if(!this.state.hasSent){this.getOtp();}}}>{this.state.hasSent?('等待'+this.state.sec+'秒'):'发送验证码'}</button> */}
          {/* <h4>病种：</h4>
          <div
            className="illness"
            onClick={() => {
              this.setState({ showIllness: true });
            }}
          >
            {this.state.illness.name}
          </div> */}
          <h4>职称<span className="asterisk">*</span>：</h4>
          <input
            max="8"
            value={this.state.jobtitle}
            onChange={(v) => {
              this.setState({ jobtitle: v.target.value });
            }}
          />
          <h4>昵称<span className="asterisk">*</span>：</h4>
          <input
            max="8"
            value={this.state.nickname}
            onChange={(v) => {
              this.setState({ nickname: v.target.value });
            }}
          />
          <button
            className="sub"
            onClick={() => {
              this.login();
            }}
          >
            Login
          </button>
          <div>*内容为必填</div>
        </div>
      </div>
    );
  }
}

export default LiveClientRoom;
